/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicaidCaseListRow } from './MedicaidCaseListRow';
import {
    MedicaidCaseListRowFromJSON,
    MedicaidCaseListRowFromJSONTyped,
    MedicaidCaseListRowToJSON,
    MedicaidCaseListRowToJSONTyped,
} from './MedicaidCaseListRow';
import type { MedicaidCasePresetCounts } from './MedicaidCasePresetCounts';
import {
    MedicaidCasePresetCountsFromJSON,
    MedicaidCasePresetCountsFromJSONTyped,
    MedicaidCasePresetCountsToJSON,
    MedicaidCasePresetCountsToJSONTyped,
} from './MedicaidCasePresetCounts';

/**
 * 
 * @export
 * @interface MedicaidCaseList
 */
export interface MedicaidCaseList {
    /**
     * 
     */
    cases: Array<MedicaidCaseListRow>;
    /**
     * 
     */
    preset_counts: MedicaidCasePresetCounts;
    /**
     * 
     */
    next_cursor: string | null;
}

/**
 * Check if a given object implements the MedicaidCaseList interface.
 */
export function instanceOfMedicaidCaseList(value: object): value is MedicaidCaseList {
    if (!('cases' in value) || value['cases'] === undefined) return false;
    if (!('preset_counts' in value) || value['preset_counts'] === undefined) return false;
    if (!('next_cursor' in value) || value['next_cursor'] === undefined) return false;
    return true;
}

export function MedicaidCaseListFromJSON(json: any): MedicaidCaseList {
    return MedicaidCaseListFromJSONTyped(json, false);
}

export function MedicaidCaseListFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCaseList {
    if (json == null) {
        return json;
    }
    return {
        
        'cases': ((json['cases'] as Array<any>).map(MedicaidCaseListRowFromJSON)),
        'preset_counts': MedicaidCasePresetCountsFromJSON(json['preset_counts']),
        'next_cursor': json['next_cursor'],
    };
}

export function MedicaidCaseListToJSON(json: any): MedicaidCaseList {
    return MedicaidCaseListToJSONTyped(json, false);
}

export function MedicaidCaseListToJSONTyped(value?: MedicaidCaseList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cases': ((value['cases'] as Array<any>).map(MedicaidCaseListRowToJSON)),
        'preset_counts': MedicaidCasePresetCountsToJSON(value['preset_counts']),
        'next_cursor': value['next_cursor'],
    };
}

